export default "__VITE_ASSET__CYdLaYkX__"